module.exports = __webpack_public_path__ + "files/839ffbc11cb3ece9c047480676fc395f.svg";